import React, {PropTypes} from 'react'
import {connect} from 'react-redux'
import styles from './webapps.scss'
import nesProp from 'nested-property'
import {getDSDataSets, getDSDataSet, getDSDocumentTemplate, disableBackgroundProcesses, setNotification, getLists, createPrintableDocument} from './../../state/actions/index'
import {customModalStyles, customModalStylesForFillForm} from './../DSDocuments/documentsHelpers'
import i18n from 'lib/i18n'
import WarningModal from './../DSDocuments/WarningModal'
import OpenDocumentToFillModal from './../DSDocuments/OpenDocumentToFillModal'
import { SelectWrapper } from './../../components/shared/select/SelectWrap'
import cs from 'classnames'
import c from 'state/constants'

const PDF_API_URL = "/api/getFilledPrintablePdfDocument"

const _ = i18n('webapps')


@connect(
    ({
        app: {lang, security: {WebAppTypes}},
        office: { brokers }
    }) => ({
        lang,
        WebAppTypes,
        brokers
    }
))
export default class WebAppFillDocDom extends React.Component {
	static propTypes = {
		webApp: PropTypes.object,
        img: PropTypes.string.isRequired,
        desc: PropTypes.string.isRequired,
        onSave: PropTypes.string.func,
        onCancel: PropTypes.string.func
	}

    constructor(props) {
        super(props)

        //+++++++++++++++++++++++
        // First time init

        // init broker stuff
        let brokerOptions = []
        if (props.brokers) {
            for (const key in props.brokers) {
                if (props.brokers[key].brokerNumber) {
                    brokerOptions.push({
                        label: props.brokers[key].main.name + "  " + props.brokers[key].brokerNumber,
                        value: props.brokers[key].brokerNumber,
                    })
                }
            }
        }

        this.state = {
            documentTemplate: null,
            brokerOptions,
            brokerNumber:  brokerOptions && brokerOptions[0].value || "",
            language: props.lang,
            documentTemplateId: props.webApp.documentTemplate && props.webApp.documentTemplate._id,

            warningModalOpen: false,

            dataSet: null,
            optionsLists: null
        }

        this.startLoading()

        // +++++++++++++++++++++++++++++++++++++++
        // async inits, late set state
        new Promise(async () => {

            // ++++++++++++++++++++++++++++
            // init template stuff
            let initResult = await this.initTemplate(
                this.state.brokerNumber,
                this.state.language,
                this.state.documentTemplate,
                this.state.documentTemplateId,
                ""
            )

            let documentTemplate = initResult.documentTemplate
            let dataSet = initResult.dataSet
            let optionsLists = initResult.optionsLists
            // -------------------------


            this.setState({
                documentTemplate,
                dataSet,
                optionsLists
            }, () => {
                this.stopLoading()
            })
        })
        //---------------------------------------
    }

    /**
     *
     * @param {*} nextProps
     * @param {*} nextState
     */
    componentWillUpdate(nextProps, nextState) {
        let {brokerNumber, language, documentTemplate, documentTemplateId} = this.state


        let oldStateAffected = {
            documentTemplate: nextState.documentTemplate,
            dataSet: nextState.dataSet,
            optionsLists: nextState.optionsLists
        }

        let newStateToSet = {
            ...oldStateAffected
        }

        // NO CODE OUTSIDE...!

        // ALL YOUR CODE INSIDE PROMISE
        new Promise(async (resolve) => {

            //++++++++++++++++++++++++++
            // fetch template affected
            if (
                documentTemplateId !== nextState.documentTemplateId ||
                (!documentTemplate && documentTemplateId) ||
                (documentTemplate && (documentTemplate._id !== documentTemplateId)) ||
                language !== nextState.language ||
                brokerNumber !== nextState.brokerNumber
            ) {
                // args should be strictly from the nextState values
                let initResult = await this.initTemplate(
                    nextState.brokerNumber,
                    nextState.language,
                    nextState.documentTemplate,
                    nextState.documentTemplateId,
                    ""
                )

                // altering new state, affected values by incoming new values
                newStateToSet.documentTemplate = initResult.documentTemplate
                newStateToSet.dataSet = initResult.dataSet
                newStateToSet.optionsLists = initResult.optionsLists
            }
            //-----------------------------



            //+++++++++++++++++++++++++++++
            // checking the altered state values, if differ from originally expected nextState values
            // EXIT point
            if (JSON.stringify(newStateToSet) !== JSON.stringify(oldStateAffected)) {

                //this.startLoading()

                return this.setState(newStateToSet, () => {
                    //this.stopLoading()

                    console.log("STATE CAHNGED ", this.state.brokerNumber)

                    resolve()
                })
            }

            // Arrived here means nothing to alter/update by newly set state or props values
            // EXIT point
            return resolve()
        })
    }


    /**
     * Setup all conditions for this module
     */
    async initTemplate( brokerNumber, language, documentTemplate, documentTemplateId ) {
        const { dispatch } = this.props

        if (!documentTemplate || (String(documentTemplate._id) !== String(documentTemplateId))) {
            documentTemplate = await dispatch(getDSDocumentTemplate(documentTemplateId))
        }

        if (!documentTemplate) {
            console.error("No template found by id: " + documentTemplateId)
            return
        }

        let dataSetId = documentTemplate.dataSetId && documentTemplate.dataSetId.datasetId
        let datasetName = documentTemplate.dataSetId && documentTemplate.dataSetId.datasetName
        let dataSet
        let optionsLists

        try {
            // update the list of datasets in database
            await dispatch(getDSDataSets())

            // get calues
            dataSet = await dispatch(getDSDataSet(
                datasetName,
                (dataSetId === 'clientId') ? "" : null,
                brokerNumber,
                language,
                null,
                null
            ))

            await dispatch(disableBackgroundProcesses(true))

            if (dataSet && dataSet.placeholders) {
                const listsToGet = []
                for (let placeholder of dataSet.placeholders) {
                    if (placeholder.placeholderList) {
                        listsToGet.push({ placeholderName: placeholder.placeholderName, placeholderList: placeholder.placeholderList })
                    }
                }

                if (listsToGet && listsToGet.length > 0) {
                    const getListRequest = await dispatch(getLists(listsToGet, language))

                    if(getListRequest) {
                        optionsLists = getListRequest
                    }
                }
            }

        } catch (error) {
            console.error(error)
            dispatch(setNotification(_('error') + " " + JSON.stringify(error), 'error'))
        }

        return {
            documentTemplate,
            dataSet,
            optionsLists
        }
    }

    /**
     * Start loading anything.
     * Not a state driven status flag, because not required a rerender in case of change
     */
    startLoading() {
        this.isLoaded = false
    }

    /**
     * Stop loading anything.
     * Not a state driven status flag, because not required a rerender in case of change
     * @param {*} forceUpdate - can be enforced optionally a rerender but very rare to be necessary.
     */
    stopLoading() {
        this.isLoaded = true
        this.forceUpdate()
    }

    /**
     * Open warning modal
     * @param {*} isThereXSSFiltered
     * @param {*} suspectValues
     */
    async openWarningModalForXssIssue(isThereXSSFiltered, suspectValues) {
        return this.setState({warningModalOpen: isThereXSSFiltered ? suspectValues : false})
    }

    /**
     *
     * @param {*} newBrokerNumber
     */
    onChangeBroker(newBrokerNumber) {
        let {brokerNumber} = this.state

        if (newBrokerNumber !== brokerNumber) {
            this.setState({brokerNumber: newBrokerNumber})
        }
    }

    /**
     * This will generate the PDF and forward to the ling toward it to print.
     * @param {Object} oneDocument
     */
    async openNewTabByDocumentId(printableDocumentId) {
        let linkForPdfDownload = PDF_API_URL + "/" + printableDocumentId
        let w = window.open(linkForPdfDownload , '_blank', 'noopener,noreferrer')

        new Promise((resolve) => {
            w.addEventListener('load', ()=>{
                resolve()
            }, true)
        })
    }

    /**
     * Provides initial arguments for creating a new printable document record
     * @param {*} packageId - this is a fake data, can be anything. (The existence can't be avoided,
     * without an agrerssive modifications of the reused, components of the Digital Signature system.)
     * @returns
     */
    generatePrintableDocumentProps(packageId) {
        let {documentTemplate, language, brokerNumber} = this.state

        return {
            _id: "no_id_but_required",
            cursor: 0,
            language: language,
            documentTemplate,
            brokerFilledValues: [],
            packageId,
            clientId: "",
            brokerNumber
        }
    }

    /**
     * This information is necessary to exists for printable document as well, because the code is reused of
     * Digital signature system, what was build for signable document originaly, an are based on signers and stuffs.
     * The cost is to try to follow the schemas, to be able to use the code, without modify the original functionalities.
     * @returns
     */
    generatePrintableDocumentStakeholder() {
        return  {
            _id: "noid",
            firstName: "",
            lastName: "",
            email: "",
        }
    }

    /**
     * The component local onsave functionality.
     * Resolve local jobs and call the parents on save.
     * @param {*} printableDocArgumentsForCreate
     * @param {*} oneDocumentUpdatableProps
     */
    async onSave(printableDocArgumentsForCreate, oneDocumentUpdatableProps, canvasImages) {
        const {dispatch} = this.props

        // extend the document object by the broker filled values and stuffs by the template filler module
        printableDocArgumentsForCreate = {
            ...printableDocArgumentsForCreate,
            ...oneDocumentUpdatableProps,
            documentTemplateId: printableDocArgumentsForCreate.documentTemplate,
            _id: null
        }

        // save the document in mongo to have reference id for generating printing link
        let printableDocumentRecord = await dispatch(createPrintableDocument(printableDocArgumentsForCreate, canvasImages))

        // open new tab by the saved dpocuent id
        await this.openNewTabByDocumentId(printableDocumentRecord._id)

        return printableDocumentRecord
    }

    /**
     * Render hook of class based component
     * @returns
     */
    render() {
        if (!this.isLoaded) {
            return <div>{_("loading")}</div>
        }

        const {img, desc, dispatch} = this.props
        let {documentTemplate, dataSet, optionsLists, language, warningModalOpen, brokerNumber,
            brokerOptions} = this.state

        let fakePackageId = "noid"
        let printableDocArgumentsForCreate = this.generatePrintableDocumentProps(fakePackageId)
        let fakeStakeHolder = this.generatePrintableDocumentStakeholder()

        return <div className={cs(styles.item, styles.itemFlex)} key={"WebAppFillDocDomMainKey"}>
            <div className={styles.descContainer} key={"WebAppFillDocDomDescriptionKey"}>
                <span>{desc}</span>
            </div>

            <form key={"WebAppFillDocDomFormKey"} className={styles.webAppForm}>
                <div className={styles.formInputContainer} key={"WebAppFillDocDomFormBrokerNrKey"}>
                    <label className={styles.formLabel}>{_('brokerNumber')} </label>
                    <div className={cs(styles.formInput, styles.formInputCreatableSelect)}>
                        <SelectWrapper
                            value={brokerNumber}
                            options={brokerOptions}
                            isClearable={false}
                            isDisabled={false}
                            onChange={item => this.onChangeBroker(item.value)}
                            key={"WebAppFillDocDomFormBrokerSelectorKey"}
                        />
                    </div>
                </div>
            </form>

            <div className={styles.docFillerContainer}>
                <OpenDocumentToFillModal
                    parentModule={c.WEBAPPS}
                    extraClassNameForContainer={styles.iframeContainer}
                    renderTemplateOnly={true}
                    contentLabel={""}
                    dataForEditDocument={{
                        oneDocument: printableDocArgumentsForCreate,
                        dataSet,
                        optionsLists
                    }}
                    stakeholders={[fakeStakeHolder]}
                    packageDSDocuments={[printableDocArgumentsForCreate]}
                    lang={language}
                    packageId={fakePackageId}
                    showWarningXss = {(isThereXSSFiltered, suspectValues) => {
                        return this.openWarningModalForXssIssue(isThereXSSFiltered, suspectValues)}
                    }
                    didClose={(templateFormValues)=>{
                        this.setState({
                            dataSet: null,
                            optionsLists: null
                        })
                        this.stopLoading()
                        dispatch(disableBackgroundProcesses(false))
                    }}
                    onCancel={(argu) => {
                        this.props.onCancel(argu)
                    }}
                    onSave={async (oneDocumentUpdatableProps, canvasImages) => {
                        let printableDocumentRecord = await this.onSave(
                            printableDocArgumentsForCreate,
                            oneDocumentUpdatableProps,
                            canvasImages
                        )

                        // call the parent onSave methode, to do further action when all the jobs are done
                        await this.props.onSave(printableDocumentRecord)
                    }}
                    key={"WebAppOpenDocumentToFillModal"}
                ></OpenDocumentToFillModal>
            </div>

            <WarningModal
                isOpen={Boolean(warningModalOpen)}
                style={customModalStyles}
                contentLabel={""}
                didClose={()=>{
                    this.setState({warningModalOpen: false})
                }}
                key={"WebAppWarningModal"}
            >
            </WarningModal>
	    </div>
    }
}



// WEBPACK FOOTER //
// ./components/webapps/WebAppFillDocDom.jsx